import { Button } from "@/components/primitives/Button"
import { CookieIcon } from "@/components/primitives/icons/CookieIcon"
import { useCookieConsent } from "@/lib/useCookieConsent"

export function CookieBanner() {
  const { showBanner, acceptCookies, rejectCookies } = useCookieConsent()

  if (import.meta.env.DEV || !showBanner) return null

  return (
    <div className="fixed right-0 bottom-0 z-overlay p-6">
      <div className="max-w-lg rounded-xl bg-raised p-5 shadow-lg ring-1 ring-border">
        <div className="flex items-start gap-4">
          <CookieIcon className="mt-0.5 shrink-0 text-disabled" size={20} />
          <div className="flex-1">
            <p className="mb-3 text-muted">
              A better experience starts with cookies. We use{" "}
              <a href="/cookies" className="underline hover:text-default">
                cookies
              </a>{" "}
              to improve our product. Entirely your choice.
            </p>
            <div className="flex gap-3">
              <Button variant="outline" size="small" onClick={rejectCookies}>
                Reject
              </Button>
              <Button variant="attention" size="small" onClick={acceptCookies}>
                Accept
              </Button>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}
